import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import cx from 'classnames';
import ScalableImg from 'common/scalable-img';
import { truncateText } from 'helper/anytime-booking';
import WithTooltip from 'components/v2/with-tooltip-hoc';
import { PriceSurgeIcon } from 'components/v2/anytime-booking/common/price-surge-icon';

import styles from './styles.less';

const SERVICE_TYPE_DESCRIPTION_MAXLEN = 42;

const CommonSelector = ({
  onSelect,
  selectedKey,
  options,
  defaultOptionIcon,
}) => {
  const onClick = useCallback(
    option => () => {
      if (!option.disabled) {
        onSelect(option);
      }
    },
    [onSelect],
  );

  return (
    <div className={styles.commonSelector}>
      {options.map(option => (
        <WithTooltip
          key={option.key}
          hasTooltip={!!option.disabledHint}
          title={option.disabledHint}
          placement={'bottom'}
        >
          <a
            key={option.key}
            className={cx(styles.option, {
              [styles.selected]: option.key === selectedKey,
              [styles.disabled]: option.disabled,
            })}
            onClick={onClick(option)}
          >
            {(option.icon || defaultOptionIcon) && (
              <ScalableImg
                className={styles.icon}
                src={option.icon || defaultOptionIcon}
                alt={option.name}
              />
            )}
            <div className={styles.intro}>
              <div className={styles.price}>
                <div className={styles.name}>{option.name}</div>
                <div className={styles.estimatePriceContainer}>
                  <div className={styles.estimatePrice}>{option.fare}</div>
                  <PriceSurgeIcon priceSurgeInfo={option} />
                </div>
              </div>

              {option.disabled && option.disabledReason ? (
                <div className={styles.description}>
                  {option.disabledReason}
                </div>
              ) : (
                <div className={styles.description}>
                  {truncateText(
                    option.description,
                    SERVICE_TYPE_DESCRIPTION_MAXLEN,
                  )}
                </div>
              )}
            </div>
          </a>
        </WithTooltip>
      ))}
    </div>
  );
};

CommonSelector.defaultProps = {
  selectedKey: undefined,
  defaultOptionIcon: undefined,
};

CommonSelector.propTypes = {
  onSelect: PropTypes.func.isRequired,
  selectedKey: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  defaultOptionIcon: PropTypes.string,
};

export default CommonSelector;
